import EspecialidadeModel from "../models/especialidadeModel";

import { IService } from "./base/iService";

export default class EspecialidadeService extends IService<EspecialidadeModel> {
    constructor() {
        super("Especialidade");
    }
}